import { getServerPrintConfiguration } from "core/services/api";

const getPrintConfiguration = async () => {
  const localPrintConfiguration = localStorage.getItem("printConfiguration");

  if (localPrintConfiguration) {
    const { datetime, configuration } = JSON.parse(localPrintConfiguration);
    const storedDatetime = new Date(datetime);

    // Check if the stored datetime is less than 12 hours old
    if ((Date.now() - storedDatetime.getTime()) < (12 * 60 * 60 * 1000)) {
      return configuration; // Return the cached configuration if valid
    }
  }

  // Fetch from API if no valid cached configuration
  try {
    const res = await getServerPrintConfiguration();

    // Update localStorage with the new configuration and current datetime
    const printConfiguration = res; // assuming res contains the configuration
    localStorage.setItem("printConfiguration", JSON.stringify({ datetime: new Date(), configuration: printConfiguration }));

    return printConfiguration; // Return the new configuration
  } catch (err) {
    console.error("Error fetching print configuration:", err);
    return null; // Return null or handle the error as needed
  }
}

export { getPrintConfiguration };